import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DispatchType } from '../../../state/configureStore';
import { Container, Row } from 'reactstrap';
import { searchInObject } from '../../../core/helpers/search';
import { ApplicationState } from '../../../state/ApplicationState';
import { ClipLoader } from '../../components/ClipLoader';
import { TachoConfirmationModal } from '../../components/TachoConfirmationModal';
import { DistributorsToolbar } from './DistributorsToolbar';
import { deleteDistributorThunk, fetchDistributorsThunk } from '../../../state/distributors/reducer';
import { DistributorsTable } from './DistributorsTable';
import { UpdateDistributorModal } from '../../modals/distributors/UpdateDistributorModal';
import { AddDistributorModal } from '../../modals/distributors/AddDistributorModal';
import { Distributor } from '../../../core/domainModels/distributors/Distributor';

export const DistributorsPage = () => {
    const dispatch = useDispatch<DispatchType>();
    const distributors = useSelector((state: ApplicationState) => state.distributors.distributors);
    const fetchUsersPending = useSelector((state: ApplicationState) => state.distributors.fetchDistributorsPending);
    const deleteUsersPending = useSelector((state: ApplicationState) => state.distributors.deleteDistributorPending);
    const deleteUsersError = useSelector((state: ApplicationState) => state.distributors.deleteDistributorError);
    const [isConfirmRemoveModalOpen, setIsConfirmRemoveModalOpen] = useState(false);
    const [isOpenAddDistributorModal, setIsOpenAddDistributorModal] = useState(false);
    const [isOpenUpdateDistributorModal, setIsOpenUpdateDistributorModal] = useState(false);
    const [selectedDistributors, setSelectedDistributors] = useState<Array<Distributor>>([]);
    const [searchQuery, setSearchQuery] = useState('');
    const distributorsToShow = useMemo(() => {
        return searchQuery
            ? distributors.filter((distributors: Distributor) => searchInObject(distributors, searchQuery))
            : distributors;
    }, [distributors, searchQuery]);
    return (
        <Container fluid className="flexColumnFullHeightContainer">
            <DistributorsToolbar
                selectedDistributors={selectedDistributors}
                openAddDistributorModal={() => setIsOpenAddDistributorModal(!isOpenAddDistributorModal)}
                openUpdateDistributorModal={() => setIsOpenUpdateDistributorModal(!isOpenUpdateDistributorModal)}
                openConfirmRemoveModal={() => setIsConfirmRemoveModalOpen(!isConfirmRemoveModalOpen)}
                onRefresh={() => dispatch(fetchDistributorsThunk())}
                onSearchQueryChanged={setSearchQuery}
            />
            <Row className="ag-theme-balham tabTable flexGrowScrollableChild g-0">
                {fetchUsersPending ? (
                    <ClipLoader />
                ) : (
                    <DistributorsTable
                        onDistributorDoubleClicked={() => setIsOpenUpdateDistributorModal(!isOpenUpdateDistributorModal)}
                        onSelectionChanged={setSelectedDistributors}
                        distributors={distributorsToShow}
                    />
                )}
            </Row>
            <TachoConfirmationModal
                isOpen={isConfirmRemoveModalOpen}
                onSubmit={() => dispatch(deleteDistributorThunk(selectedDistributors[0].id))}
                onToggle={() => setIsConfirmRemoveModalOpen(!isConfirmRemoveModalOpen)}
                message={'distributorRemoveConfirmationMessage'}
                pending={deleteUsersPending}
                errorToTranslate={deleteUsersError}
                title={'distributorDelete'}
            />
            <AddDistributorModal
                isOpen={isOpenAddDistributorModal}
                onToggle={() => setIsOpenAddDistributorModal(!isOpenAddDistributorModal)}
            />

            <UpdateDistributorModal
                distributor={selectedDistributors[0]}
                isOpen={isOpenUpdateDistributorModal}
                onToggle={() => setIsOpenUpdateDistributorModal(!isOpenUpdateDistributorModal)}
            />
        </Container>
    );
};
